/* tslint:disable:max-line-length */
import { IconTypeProps } from '@mm/icons';
import React from 'react';

export const DatabaseIcon = ({
  className,
  size,
  color = '#262626',
}: IconTypeProps) => {
  const styles = {
    width: size,
    height: size,
  };
  return (
    <svg
      className={className}
      width="71"
      height="74"
      viewBox="0 0 71 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styles}
    >
      <g clipPath="url(#clip0_473_32557)">
        <path
          d="M11.0275 55.0539C12.8543 55.8155 14.7805 56.3049 16.7453 56.5435C28.5731 57.9794 40.6307 57.8632 52.3625 55.7547C53.7681 55.502 55.2366 55.1913 56.2205 54.0682C57.6066 52.4857 57.0255 49.8437 53.136 50.004C51.47 50.0728 49.8438 50.401 48.2331 50.828C49.4729 49.6923 50.1728 48.2155 50.1728 46.6231C50.1728 38.5348 50.1728 34.1832 50.1728 28.8581C50.1728 28.8571 50.1728 28.8561 50.1728 28.8551C50.1721 28.7722 50.1621 16.7993 50.1696 16.717C50.4311 13.8367 48.5416 12.4476 45.8657 11.279C40.0706 8.74902 33.2873 8.45605 28.6897 8.45605C23.0133 8.45605 11.4398 9.49541 7.79103 13.7905C7.33201 14.3437 7.05429 14.9196 6.95085 15.5083L6.95295 15.3613C6.24461 16.6408 6.69552 15.029 5.08252 46.1342C5.08252 50.0347 7.42737 53.5529 11.0275 55.0539ZM8.16185 18.6361C11.155 21.6019 19.2537 23.566 28.6897 23.566C37.3817 23.566 45.6001 21.3049 48.9078 18.2019C48.9763 20.8035 48.9119 18.3915 48.9399 28.4495C26.2108 38.1844 9.41075 28.6515 8.2056 28.3748L8.16185 18.6361ZM48.9399 29.7804V39.8852C43.1752 41.9133 38.8276 43.0065 35.3076 43.3049C18.3132 44.7462 9.16889 40.5031 8.25963 40.4096L8.21152 29.6988C21.2153 35.6818 35.5801 35.3621 48.9399 29.7804ZM46.5504 50.5761C39.4244 55.0491 17.266 55.352 11.1846 51.0762C9.78883 50.0945 8.28707 48.25 8.28707 46.5171L8.26535 41.6813C14.308 43.7777 21.0563 44.8372 28.4088 44.8372C36.059 44.8372 40.4174 44.1564 48.9399 41.1899V46.6231C48.9399 48.1826 48.069 49.6234 46.5504 50.5761ZM9.09935 14.1926C14.1601 9.38953 34.8433 7.8117 45.3729 12.4091C47.1986 13.207 48.966 14.1831 48.9624 16.1728C47.4253 19.149 38.918 22.3331 28.6897 22.3331C15.6621 22.3331 4.76075 18.126 9.09935 14.1926Z"
          fill={color}
        />
        <path
          d="M49.5453 4.70374L47.9111 9.66093C47.8044 9.9844 47.9801 10.3328 48.3036 10.4387C48.6113 10.5439 48.9717 10.3804 49.0814 10.0462L50.7156 5.09062C50.8223 4.76715 50.6466 4.418 50.3239 4.31205C50.0004 4.20369 49.6513 4.38188 49.5453 4.70374Z"
          fill={color}
        />
        <path
          d="M54.9584 8.91517L52.0921 11.0871C51.6213 11.4437 51.8767 12.1948 52.4653 12.1948C52.8349 12.1948 52.7666 12.0677 55.7032 9.89762C55.9745 9.69214 56.0275 9.30526 55.822 9.03396C55.6165 8.76346 55.2313 8.70808 54.9584 8.91517Z"
          fill={color}
        />
        <path
          d="M52.4027 15.3006C52.2968 15.6249 52.4742 15.9724 52.7977 16.0776C54.5402 16.6445 56.1115 16.6378 56.0291 16.6298C56.3622 16.6298 56.6367 16.3641 56.6456 16.0294C56.6544 15.6891 56.3855 15.4057 56.0452 15.3969C55.0692 15.372 54.1052 15.2067 53.1797 14.9057C52.8571 14.7997 52.5079 14.9771 52.4027 15.3006Z"
          fill={color}
        />
        <path
          d="M18.845 28.9606C19.5303 28.9606 20.2152 28.453 20.2922 27.7238C20.3984 26.7304 19.3245 25.9076 18.3955 26.2621C17.8424 26.4758 17.5389 26.9808 17.5246 27.5391C17.5118 28.044 18.0844 28.9606 18.845 28.9606Z"
          fill={color}
        />
        <path
          d="M28.1598 29.5774C28.8475 29.5774 29.5298 29.0685 29.6077 28.3397C29.7181 27.2904 28.5052 26.4049 27.5072 26.9752C27.1027 27.2096 26.8522 27.651 26.8394 28.1559C26.819 28.9546 27.3936 29.5774 28.1598 29.5774Z"
          fill={color}
        />
        <path
          d="M38.0232 28.6187C39.348 28.6187 40.0416 27.0156 38.9102 26.1449C38.4809 25.8144 37.8854 25.7157 37.3715 26.0165C36.2399 26.6686 36.6017 28.6187 38.0232 28.6187Z"
          fill={color}
        />
        <path
          d="M18.2286 39.7826C18.9139 39.7826 19.5988 39.275 19.6758 38.5457C19.7881 37.4948 18.5703 36.6087 17.576 37.1804C17.1707 37.414 16.9219 37.8555 16.9082 38.3603C16.8879 39.1612 17.4636 39.7826 18.2286 39.7826Z"
          fill={color}
        />
        <path
          d="M27.5436 40.3998C28.2313 40.3998 28.9137 39.8909 28.9916 39.1621C29.1031 38.1017 27.8678 37.2263 26.8919 37.7976C26.4865 38.0312 26.2369 38.4719 26.2232 38.9767C26.2016 39.7802 26.7804 40.3998 27.5436 40.3998Z"
          fill={color}
        />
        <path
          d="M37.4065 39.4399C38.7342 39.4399 39.4222 37.8356 38.2934 36.967C37.3623 36.2518 36.1161 36.8415 36.0862 38.0184C36.0733 38.5225 36.6404 39.4399 37.4065 39.4399Z"
          fill={color}
        />
        <path
          d="M17.9191 47.6599C17.0579 48.1562 17.0197 49.5081 17.8565 50.0534C18.6925 50.5971 19.9128 50.0156 20.0189 49.0252C20.1312 47.9743 18.9134 47.0882 17.9191 47.6599Z"
          fill={color}
        />
        <path
          d="M27.2336 48.277C26.3724 48.7732 26.3341 50.1252 27.171 50.6705C28.0095 51.2159 29.2292 50.6287 29.3333 49.6423C29.4448 48.5991 28.2353 47.701 27.2336 48.277Z"
          fill={color}
        />
        <path
          d="M37.0958 47.3183C36.2341 47.8176 36.198 49.1663 37.034 49.7111C37.8725 50.2564 39.0922 49.6693 39.1963 48.6829C39.3111 47.6094 38.0544 46.7478 37.0958 47.3183Z"
          fill={color}
        />
        <circle cx="45.5051" cy="43.9274" r="18.3" fill="#FBFCFE" />
        <path
          d="M44.2536 33.7546C42.5936 34.4344 42.3019 34.5504 42.2143 34.5698C34.9945 38.5882 34.0253 48.9259 40.7021 53.9053C48.2727 59.5753 59.1796 54.0336 59.0132 44.514C59.0132 44.5134 59.0132 44.5134 59.0132 44.5128C58.8699 36.9445 51.5278 31.5409 44.2536 33.7546ZM41.2564 53.1628C34.9824 48.4832 35.8968 38.8972 42.6316 35.4109L44.5612 34.6274C51.1406 32.6363 57.9543 37.5173 58.0867 44.5296C58.2398 53.2933 48.2055 58.3685 41.2564 53.1628Z"
          fill={color}
        />
        <path
          d="M70.4535 66.9475C67.3714 63.5353 63.8096 59.7848 60.7846 56.4337C60.7181 56.3602 60.6319 56.3213 60.5422 56.3008C60.7299 55.7271 60.8157 55.0911 60.7509 54.5596C60.6408 53.6499 59.9729 52.9101 59.1744 52.7755C65.5529 43.4979 58.7628 30.666 47.3876 30.8966C41.6756 30.9959 36.5936 34.5478 34.5515 39.9406C33.2977 42.602 32.8437 45.6449 33.3838 48.542C34.2721 53.3073 37.8094 57.4889 42.3615 59.155C46.123 60.5318 50.4617 60.1449 53.9745 58.2406C54.3155 59.0399 55.2571 59.4211 56.139 59.4611C56.5612 60.0413 57.208 60.709 57.5099 61.0158C59.171 62.7042 60.5477 64.5562 62.2088 66.2447C62.9447 66.9927 63.6542 67.7679 64.4167 68.4888C66.6346 70.5857 67.681 70.9838 68.8141 70.8686C69.5229 70.7965 69.701 70.6482 69.5796 70.4638C69.7464 70.3946 69.8971 70.3081 70.0156 70.1944C70.7116 69.5261 71.1948 67.7691 70.4535 66.9475ZM47.4045 31.8231C54.5078 31.6698 60.5616 37.367 60.7002 44.6411C60.8765 54.357 50.7956 60.5721 42.6322 56.944C34.0944 53.1591 32.3289 43.1993 37.3937 36.7757C41.5131 31.5783 47.4663 31.8078 47.4045 31.8231ZM69.3738 69.5261C69.0402 69.8479 67.8503 69.6742 67.4605 69.242C64.5127 65.9769 61.1455 62.3068 58.1337 58.9743C58.962 58.5052 59.6676 57.9305 60.1608 57.1251C63.199 60.4874 66.7397 64.2177 69.7659 67.5688C70.0662 67.9012 69.828 69.09 69.3738 69.5261Z"
          fill={color}
        />
        <path
          d="M59.8648 34.6311L61.5217 32.2546C61.6683 32.0447 61.6164 31.7564 61.4065 31.6098C61.196 31.4638 60.9077 31.5157 60.7617 31.725L59.1048 34.1015C58.9583 34.3114 59.0101 34.6003 59.22 34.7463C59.432 34.8934 59.7197 34.8395 59.8648 34.6311Z"
          fill={color}
        />
        <path
          d="M61.8745 36.6131L64.1636 34.7704C64.3632 34.6099 64.3946 34.3186 64.2341 34.1196C64.0743 33.9199 63.7811 33.8879 63.5833 34.049L61.2931 35.8917C61.094 36.0521 61.0627 36.3435 61.2231 36.5431C61.3831 36.741 61.6734 36.7745 61.8745 36.6131Z"
          fill={color}
        />
        <path
          d="M62.5347 39.2929L64.3955 39.1892C64.6513 39.1747 64.8467 38.9563 64.8328 38.7012C64.8183 38.4449 64.5789 38.2452 64.3448 38.2639L62.4829 38.3677C62.2271 38.3821 62.0317 38.6011 62.0462 38.8562C62.061 39.1196 62.2915 39.3103 62.5347 39.2929Z"
          fill={color}
        />
        <path
          d="M47.4383 42.1091C48.8625 42.1091 50.4327 41.187 50.918 39.8291C51.3438 38.6384 51.0959 37.4695 50.2388 36.6226C48.3466 34.7533 44.5046 35.1835 44.2198 38.6891H44.2204C44.0846 40.3661 45.5095 42.1091 47.4383 42.1091ZM45.1438 38.7639C45.4537 34.9198 51.1706 36.3678 50.0458 39.5173C49.6695 40.5685 48.2445 41.3432 47.0728 41.1543C45.9563 40.9775 45.0546 39.8605 45.1432 38.7639H45.1438Z"
          fill={color}
        />
        <path
          d="M40.3189 50.2707C40.3934 50.2713 54.4491 50.3727 54.386 50.3727C54.7421 50.3727 54.9466 49.98 54.8589 49.7056C54.3945 48.2399 53.5802 46.2168 52.3377 44.9055C49.5401 41.9518 45.2329 42.678 42.6845 45.0841C41.4649 46.2349 40.4962 47.8176 39.8828 49.6615C39.7835 49.9618 40.006 50.2682 40.3189 50.2707ZM51.6651 45.5425C52.4571 46.3785 53.2044 47.7501 53.7949 49.442L40.9805 49.3491C43.2645 43.5169 48.8347 42.5555 51.6651 45.5425Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_473_32557">
          <rect
            width="70"
            height="73"
            fill="white"
            transform="translate(0.992676 0.890137)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
